// Colocated strings for ItemPhotoDialog (SKILL.md rule 11, PLATFORM.md §6 decision 15).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// The dialog's two strings, factored out of IssuesGrid with the dialog (AM_ABSORPTION_PLAN step
// C5a): the card title `photo` and the button `close`, each the value IssuesGrid rendered in all
// 10 locales (so issue-analysis's dialog reads the same). IssuesGrid keeps its own `photo` (its
// column header); `close` left it with the dialog. Standalone asset-management's grid dialog used
// the same two keys with the same English ("Photo", "Close").
//
// Keep the imports plain: no `with { type: 'json' }` (Vite serves transformed JSON as JavaScript
// and the browser rejects the attribute).
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
